import styled, { createGlobalStyle } from 'styled-components'
import { GatsbyImage } from 'gatsby-plugin-image'

import FairplexBook from 'fonts/FairplexWide-Book.woff2'
import FairplexBookItalic from 'fonts/FairplexWide-BookItalic.woff2'
import FairplexMedium from 'fonts/FairplexWide-Medium.woff2'
import FairplexMediumItalic from 'fonts/FairplexWide-MediumItalic.woff2'
import VerlagBlack from 'fonts/Verlag-Black.woff2'
import VerlagBold from 'fonts/Verlag-Bold.woff2'
import VerlagBoldItalic from 'fonts/Verlag-BoldItalic.woff2'
import VerlagLight from 'fonts/Verlag-Light.woff2'

const GlobalStyles = createGlobalStyle`
  html {
    font-size: 62.5%;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    box-sizing: border-box;
  }

  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }

  body {
    font-family: VerlagBold, sans-serif;
    font-size: 1.2rem;
    margin: 0;
    overscroll-behavior: none;
  }

  header {
    display: contents;
  }

  main {
    padding: 0 36px;
    @media (max-width: 767px) {
      padding: 0 16px;
    }
  }

  footer {
    display: contents;
  }

  button {
    border: none;
    background: none;
    padding: 0;
    font-family: VerlagBold, sans-serif;
  }

  a {
    color: black;
  }

  @font-face {
    font-family: FairplexBook;
    src: url(${FairplexBook});
    font-display: block;
  }

  @font-face {
    font-family: FairplexBook;
    font-style: italic;
    src: url(${FairplexBookItalic});
    font-display: block;
  }

  @font-face {
    font-family: FairplexMedium;
    src: url(${FairplexMedium});
    font-display: block;
  }

  @font-face {
    font-family: FairplexMedium;
    font-style: italic;
    src: url(${FairplexMediumItalic});
    font-display: block;
  }

  @font-face {
    font-family: VerlagBlack;
    src: url(${VerlagBlack});
    font-display: block;
  }

  @font-face {
    font-family: VerlagBold;
    src: url(${VerlagBold});
    font-display: block;
  }

  @font-face {
    font-family: VerlagBold;
    font-style: italic;
    src: url(${VerlagBoldItalic});
    font-display: block;
  }

  @font-face {
    font-family: VerlagLight;
    src: url(${VerlagLight});
    font-display: block;
  }

  :root {
    --darkGrey: #434343;
    --mediumGrey: #878787;
    --lightGrey: #afafaf;
    --green: #88997d;
    --orange: #d35f19;
  }
`

export default GlobalStyles

export const MouseAvailable = styled.div`
  display: none;
  @media (pointer: fine) and (hover: hover) and (min-width: 500px) {
    display: contents;
  }
`

export const TouchAvailable = styled.div`
  display: none;
  @media (pointer: coarse) and (hover: none), (max-width: 499px) {
    display: contents;
  }
`

/* TODO: the nth-child thing is VERY hacky, as it depends on gatsby-plugin-image's placeholder being the 2nd div */
/* we do this because the built-in DOMINANT_COLOR doesn't do a very good job with these swatches */
/* the attrs / style / css variable thing is for efficiency, so we're not generating hundreds of instances */

export const ColorPlaceholderImage = styled(GatsbyImage).attrs(props => ({
  style: {
    '--background': props.background
  }
}))`
  & > div:nth-child(2) {
    background: var(--background) !important;
    inset: 1px !important;
    position: absolute !important;
  }
`
